/**
 *
 * leave request Page
 *
 */
import Select from "react-select"
import React, { useState, useEffect, useRef } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import { Table } from "reactstrap"
import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Badge,
  Input,
  Spinner,
} from "reactstrap"
import moment from "moment"
import { withRouter, Link } from "react-router-dom"
import { connect, useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty } from "lodash"
//Import Styles
import "./styles.scss"
import ButtonSpinner from "../../components/ButtonSpinner"
//date format
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import SimpleReactValidator from "simple-react-validator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
// import { CSVExport } from "react-bootstrap-table2-toolkit"
//Components
import * as manageUnassignedAction from "../../store/dW5hc3NpZ25lZEVj/actions"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as permissionAction from "../../store/cGVybWlzc2lvbg/actions"
import { ToastContainer, toast } from "react-toastify"
import api from "helpers/Api"

const UnassignedEc = (props) => {
  const title = "Unassigned EC"

  const { searchBarStyle, dispatch, location } = props
  // const { SearchBar } = Search
  console.log(location, "location")

  const specificDispatch = useDispatch()

  const simpleValidator = useRef(new SimpleReactValidator())
  const [, forceUpdate] = useState()

  useEffect(() => {
    dispatch(manageUnassignedAction.loadRecordsMetaData())
    // setTimeout(() => {
    dispatch(
      manageUnassignedAction.loadManageunassignedList({
        isManageEC: false,
        page: 1,
        limit: 50,
      })
    )
    // }, 1000)
    dispatch(permissionAction.loadEmployee())
  }, [])

  //State manage details
  const update = useSelector((specificstate) => specificstate.unassignedEc)
  const { manageUnassignedMetaData = {}, unassigned_details = [] } = update

  const permissionUpdate = useSelector(
    (specificstate) => specificstate.permissionrequest
  )
  const { employee_list = [] } = permissionUpdate
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")
  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //handle Change
  const handleChange = async (e) => {
    setunassignedData({ ...unAssignedData, [e.target.name]: e.target.value })
  }

  //EMployee list

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      // if (
      //   employee.departmentId === "629481ee5ff152c59fe86130" ||
      //   employee.departmentId === "63935d9852419c76411177d8"
      // ) {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        departmentId: employee.departmentId,
        roleId: employee.roleId,
      }
      // }
    })
  console.log(employeeList, "employeeee list")
  console.log(employee_list, "employee_list")

  const employeeListDetails =
    !isEmpty(employeeList) && employeeList
      ? employeeList.filter((data) => data !== undefined)
      : []

  console.log(employeeListDetails, "employeeListDetails")
  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee =
          element && element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')
        const data = !isEmpty(element) ? element : []
        let obj = {}
        obj.value = data._id
        obj.label = labelEmployee
        obj.empCode = data.empCode
        obj.companyId = data.companyId
        obj.roleId = data.roleId
        options.push(obj)
      })
    return options
  }

  const agentOptions = createOptions(employeeList)
  //fuse options in venue name
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  const [modal, setModal] = useState(false)

  const toggle = () => setModal(false)

  // console.log("mod", modeldata)
  const [btnLoader, setBtnLoader] = useState(false)
  const [unAssignedData, setunassignedData] = useState({
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    toDate: "",
    leadNo: "",
  })

  console.log("unassigned_details", unassigned_details)
  //Filter dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  const [searchValueList, setSearchValueList] = useState({})
  // const [paymentStatus, setPaymentStatus] = useState([])

  // assign modal dropdown list
  const [companyDetails, setCompanyDetails] = useState([])
  const [branchDetails, setBranchDetails] = useState([])
  const [salesAgentList, setSalesAgentList] = useState([])

  console.log(searchValueList, "searchValueList")
  //dropdown options api

  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)
  const branchOptions =
    !isEmpty(manageUnassignedMetaData) &&
    manageUnassignedMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )
  console.log("branches", branchOptions)
  console.log(company, branch, "dropdown outputs")

  //Pagination states
  const [pageCount, setPageCount] = useState("")
  const [btnLoading, setBtnLoading] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const eventValue =  !isEmpty(events) && events.length > 0 ? events.map(val=>val.value) : []
  //Apply filter
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = !isEmpty(eventValue) && eventValue.length > 0 ? eventValue :""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
    // var searchPaymentStatus =
    //   paymentStatus && paymentStatus ? paymentStatus.value : ""
    var searchFromDate =
      unAssignedData && unAssignedData.fromDate
        ? moment(unAssignedData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      unAssignedData && unAssignedData.toDate
        ? moment(unAssignedData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      unAssignedData && unAssignedData.leadNo ? unAssignedData.leadNo : ""

    var searchvalue = {}
    searchvalue.isManageEC = false
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setSearchValueList(searchvalue)
    // console.log("searchCompany", handleFilter)
    specificDispatch(
      manageUnassignedAction.loadManageunassignedList(searchvalue)
    )
    setBtnLoading(true)
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
      setBtnLoading(false)
    }, 2000)
  }

  //reset functionalities
  // const [resetManager, setResetManager] = useState(false)
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setSalesAgent([])
    setEvents([])
    setunassignedData({
      fromDate: "",
      toDate: "",
      leadNo: "",
    })
    // setResetManager(true)
    // setTimeout(()=> {
    //   setResetManager(false)
    // }, 0)
    dispatch(
      manageUnassignedAction.loadManageunassignedList({
        isManageEC: false,
        page: 1,
        limit: 50,
      })
    )
  }

  //Unassigned table

  const [assignDetails, setAssignDetails] = useState("")
  const [searchInput, setSearchInput] = useState("")

  console.log("assignDetails", assignDetails)
  const [assignData, setAssignData] = useState({
    company: "",
    branch: "",
  })
  const [leadNo, setLeadNo] = useState("")
  // const [eventDetails, setEventDetails] = useState("")
  //Assign modal data's
  const editAssignDetails = (assignDetails) => {
    console.log(assignDetails, "assignDetails")
    setCompanyDetails({
      label: assignDetails.companyName,
      value: assignDetails.companyId,
    })
    setBranchDetails({
      label: assignDetails.branchName,
      value: assignDetails.branchId,
    })

    setAssignData({
      ...assignData,
      company: [
        { label: assignDetails.companyName, value: assignDetails.companyId },
      ],
      branch: [
        {
          label: assignDetails.branchName,
          value: assignDetails.branchId,
        },
      ],
    })
    setLeadNo(assignDetails.leadNoData)
  }
  // console.log(eventDetails, "eventDetails")
  let slNo = 0
  const unassignedDataTable = !isEmpty(unassigned_details)
    ? unassigned_details.data.map((unAssignedData, index) => {
        if (isEmpty(unAssignedData.ecPrcessStatusName)) {
          slNo = slNo + 1

          const leadDate = unAssignedData.leadDate
            ? moment(unAssignedData.leadDate)
                .subtract(5, "hours")
                .subtract(30, "minutes")
                .format(`${dateFormate} hh:mm A`)
            : []
          const eventCount =
            !isEmpty(unAssignedData) && unAssignedData.events.length > 0
              ? unAssignedData.events.length
              : 0
          return {
            _id: unAssignedData._id,
            sNo: slNo,
            routeData: unAssignedData,
            leadNo: unAssignedData.leadNo,
            leadNoData: unAssignedData.leadNo,
            branchId: unAssignedData.branchId,
            branchName: unAssignedData.branchName,
            clientName: !isEmpty(unAssignedData.clientDetails)
              ? unAssignedData.clientDetails.firstName +
                " " +
                unAssignedData.clientDetails.lastName
              : "",
            brideName: unAssignedData.brideName,
            groomName: unAssignedData.groomName,
            companyId: unAssignedData.companyId,
            companyName: unAssignedData.companyName,
            eventDetails: unAssignedData.events,
            clientCode: !isEmpty(unAssignedData.clientDetails)
              ? unAssignedData.clientDetails.clientNo
              : "",
            eventCount: eventCount,
            salesAgentName: !isEmpty(unAssignedData.leadAssign)
              ? unAssignedData.leadAssign.assignedToName
              : "--",
            events: unAssignedData.events,
            ecAssign: isEmpty(unAssignedData.ecPrcessStatusName)
              ? "Unassigned"
              : "Assigned",
            leadDate: leadDate,
            ecProcessStatus: unAssignedData.ecProcessStatus,
            paymentStatus: !isEmpty(unAssignedData.paymentStatus)
              ? unAssignedData.paymentStatus
              : "--",
            ecProcessStatusName: unAssignedData.ecPrcessStatusName,
            leadStatus: (
              <Badge
                color={
                  unAssignedData.leadAssign.leadStatus === "PS2"
                    ? "success"
                    : "danger"
                }
                style={{ padding: "6px" }}
              >
                {" "}
                {!isEmpty(unAssignedData) &&
                unAssignedData.leadAssign.leadStatus === "PS2"
                  ? "Assigned"
                  : "Unassigned"}
              </Badge>
            ),
            processStatus: unAssignedData.processStatus,
            key: index,
            cpRemarks:unAssignedData.cpRemarks?unAssignedData.cpRemarks:"--",
            cpStatus:unAssignedData.cpStatus? unAssignedData.cpStatus:"--",
            clientType: unAssignedData.leadQuotationRange,
            onlyEngagement: unAssignedData.onlyEngagement,
            onlyEngagementStatus:unAssignedData.onlyEngagementStatus
          }
        }
      })
    : []

  const unAssignedTable = !isEmpty(unassignedDataTable)
    ? unassignedDataTable.filter((data) => data !== undefined)
    : []

  //pagination table data columns
  // const { ExportCSVButton } = CSVExport

  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      formatter: (cellContent, row) => {
        const leadData = row.routeData
        return (
          <div
            // onClick={(e) => {
            //   if (e.nativeEvent.button === 0) {
            //     console.log("Left click")
            //   } else if (e.nativeEvent) {
            //     console.log("Right click")
            //   }
            // }}
            className={row.processStatus != "PS9" ? "disabled-button" : ""}
          >
            {" "}
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: {
                  row: leadData,
                  leadClientId: leadData,
                  mode: "EC",
                  prevPathname: location.pathname,
                },
              }}
            >
              <span>{row.leadNo}</span>
            </Link>
          </div>
        )
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      csvExport: false,
      headerStyle: {
        minWidth: "145px",
      },
    },
    {
      dataField: "clientType",
      text: "Client Type",
      hidden: false,
      editable: false,
      headerStyle: {
        minWidth: "100px",
      },
      
      formatter: (cellContent) => {

        let badgeStyle

        // Determine the badge style based on cell content
        switch (cellContent) {
          case "Green":
            badgeStyle = { backgroundColor: "#28a745" } // Bootstrap success color 
            break
          case "Yellow":
            badgeStyle = { backgroundColor: "#fce303" } // Yellow color
            break
          case "Orange":
            badgeStyle = { backgroundColor: "#FFA500" } //  orange color
            break
          case "Blue":
            badgeStyle = { backgroundColor: "#033dfc" } // Blue color
            break
          default:
            badgeStyle = {}
        }


        return (
          <div style={{ textAlign: "center", justifyContent: "center" }}>
            {cellContent ? (
              <span
                className={"badge"}
                style={{
                  ...badgeStyle,
                  display: "inline-block",
                  width: "35px",        // Equal width and height for a circle
                  height: "35px",
                  borderRadius: "50%",
                }}
              />
            ) : (
              <span>--</span>
              // Show '--' if cellContent is empty
            )}
          </div>)

      }
    },//
    {
      dataField: "onlyEngagement",
      text: "Only Engagement",
      hidden: false,
      editable: false,
      formatter: (cellContent,row) => {
      
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>
             
             {cellContent == true ? <span
                className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",      
                    height: "35px",
                    borderRadius: "50%",
                    color:"#c5ff00",
                    backgroundColor: "#c5ff00"
                  }}
                /> : "--"}
              </div>
              {row.onlyEngagementStatus?`(${row.onlyEngagementStatus})`:""}
            </Col>
        
          </Row>
        )


      },
      
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "companyName",
      text: "Company Name",
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "clientCode",
      text: " Client Code",
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name ",
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "cpStatus",
      text: "CP Status",
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "cpRemarks",
      text: "CP Remarks",
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name ",
      // style: {
      //   textTransform: "uppercase",
      // },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name ",
      // style: {
      //   textTransform: "uppercase",
      // },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventCount",
      text: "Event",
      // events: {
      //   onClick: () =>
      //     setAssignExpandRow(!assignExpandRow)
      // },
      formatter: (cellContent, row) => {
        return (
          <div
            className="space-between"
            // onClick={() => setEventDetails(data.events)}
          >
            <span className="badge rounded-pill bg-primary">
              {row.eventCount}
            </span>
          </div>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "salesAgentName",
      text: "Sales Agent Name",
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "ecAssign",
      text: "EC Assign",
      formatter: (cellContent, row) => {
        return (
          <Button
            color={isEmpty(row.ecProcessStatusName) ? "danger" : "success"}
            onClick={() => {
              setModal(true)
              editAssignDetails(row)
              setAssignDetails(row)
            }}
          >
            {isEmpty(row.ecProcessStatusName)
              ? "Unassigned"
              : row.ecProcessStatusName}
          </Button>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "paymentStatus",
      text: "Payment Status",
      headerStyle: {
        minWidth: "155px",
      },
    },
  ]

  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
        isManageEC: false,
        page: pageChange ? pageCount : 1,
        limit: 50,
      }

  const handleAssignDetails = (e) => {
    e.preventDefault()
    if (simpleValidator.current.allValid()) {
      const ecAssign = {
        leadId: assignDetails._id,
        assignedTo: salesAgentList.value,
      }
      setModal(false)
      console.log(ecAssign, "ecAssign details")
      specificDispatch(manageUnassignedAction.addEcAssignList(ecAssign))
      setTimeout(() => {
        toast.success("Records Assigned Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000,
        })
        specificDispatch(
          manageUnassignedAction.loadManageunassignedList(searchValue)
        )
      }, 1200)
    } else {
      simpleValidator.current.showMessages()
      forceUpdate(1)
      setModal(true)
    }
  }

  //Pagination section start //
  //Search filter
  const [searchFilter, setSearchFilter] = useState(false)
  console.log(searchInput, "searchInput")

  const handleClick = (e) => {
    // props.onSearch(input.value)
    // console.log(input.value, "inputs")
    e.preventDefault()
    setSearchFilter(true)
    specificDispatch(
      manageUnassignedAction.loadManageunassignedList({
        searchFilter: searchInput,
        isManageEC: false,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  // const MySearch = (props) => {
  //   let input

  //   const handleClick = () => {
  //     props.onSearch(input.value)
  //     console.log(input.value, "inputs")

  //     specificDispatch(
  //       manageUnassignedAction.loadManageunassignedList({
  //         searchFilter: input.value,
  //         isManageEC: false,
  //         page: pageChange ? pageCount : 1,
  //         limit: 50,
  //       })
  //     )
  //     setSearchInput(input.value)
  //     console.log(input.value, "input")
  //   }
  //   return (
  //     <div className="d-flex flex-row">
  //       <input
  //         className="form-control"
  //         placeholder="Search"
  //         ref={(n) => (input = n)}
  //         // value={!isEmpty(searchInput) ? input.value : searchInput}
  //         type="text"
  //       />
  //       <button className="btn btn-success mx-2" onClick={handleClick}>
  //         <i className="fas fa-search"></i>
  //       </button>
  //     </div>
  //   )
  // }

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }
  const exportToCsv = () => {
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = !isEmpty(eventValue) && eventValue.length > 0 ? eventValue :""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""

    var searchFromDate =
      unAssignedData && unAssignedData.fromDate
        ? moment(unAssignedData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      unAssignedData && unAssignedData.toDate
        ? moment(unAssignedData.toDate).format("YYYY-MM-DD")
        : ""
    var searchLeadNo =
      unAssignedData && unAssignedData.leadNo ? unAssignedData.leadNo : ""

    var searchvalue = {}
    searchvalue.isManageEC = false
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_all_ec_unassigned_lead`, searchvalue)
      .then((response) => {
        console.log(response.data, "response")
        const unassignedExcelDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((unAssignedData, index) => {
              // if (isEmpty(unAssignedData.ecPrcessStatusName)) {
              // slNo = slNo + 1

              const leadDate = unAssignedData.leadDate
                ? moment(unAssignedData.leadDate)
                    .subtract(5, "hours")
                    .subtract(30, "minutes")
                    .format(`${dateFormate} hh:mm A`)
                : []
              const eventCount =
                !isEmpty(unAssignedData) && unAssignedData.events.length > 0
                  ? unAssignedData.events.length
                  : 0
              return {
                _id: unAssignedData._id,
                sNo: index + 1,
                leadNo: unAssignedData.leadNo,
                branchId: unAssignedData.branchId,
                branchName: unAssignedData.branchName,
                clientName: !isEmpty(unAssignedData.clientDetails)
                  ? unAssignedData.clientDetails.firstName +
                    " " +
                    unAssignedData.clientDetails.lastName
                  : "",
                brideName: unAssignedData.brideName,
                groomName: unAssignedData.groomName,
                companyId: unAssignedData.companyId,
                companyName: unAssignedData.companyName,
                eventDetails: unAssignedData.events,
                clientCode: !isEmpty(unAssignedData.clientDetails)
                  ? unAssignedData.clientDetails.clientNo
                  : "",
                eventCount: eventCount,
                events: unAssignedData.events,
                ecAssign: isEmpty(unAssignedData.ecPrcessStatusName)
                  ? "Unassigned"
                  : "Assigned",
                salesAgentName: !isEmpty(unAssignedData.leadAssign)
                  ? unAssignedData.leadAssign.assignedToName
                  : "--",
                leadDate: leadDate,
                ecProcessStatus: unAssignedData.ecProcessStatus,
                paymentStatus: !isEmpty(unAssignedData.paymentStatus)
                  ? unAssignedData.paymentStatus
                  : "--",
                ecProcessStatusName: unAssignedData.ecPrcessStatusName,
                leadStatus: (
                  <Badge
                    color={
                      unAssignedData.leadAssign.leadStatus === "PS2"
                        ? "success"
                        : "danger"
                    }
                    style={{ padding: "6px" }}
                  >
                    {" "}
                    {!isEmpty(unAssignedData) &&
                    unAssignedData.leadAssign.leadStatus === "PS2"
                      ? "Assigned"
                      : "Unassigned"}
                  </Badge>
                ),
                cpStatus:unAssignedData.cpStatus?unAssignedData.cpStatus:"--",
                cpRemarks:unAssignedData.cpRemarks?unAssignedData.cpRemarks:"--",
                key: index,
                     clientType:unAssignedData.leadQuotationRange,
                onlyEngagement: unAssignedData.onlyEngagement == true ? "YES" : "NO"
              }
              // }
            })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo, Lead No ,Client Type, Only Engagement, Company Name ,Branch Name,Client Code, Client Name,CP Status, CP Remarks,Bride Name, Groom Name, Lead Date,Event,EC Assign",
          ]

          // console.log("followupExportDataTable123", followupExportDataTable)

          console.log("unassignedExcelDataTable", unassignedExcelDataTable)

          let usersCsv =
            !isEmpty(unassignedExcelDataTable) &&
            unassignedExcelDataTable.reduce((acc, user) => {
              const {
                sNo,
                leadNo,
                clientType,
                onlyEngagement,
                companyName,
                branchName,
                clientCode,
                clientName,
                cpStatus,
                cpRemarks,
                brideName,
                groomName,
                leadDate,
                eventCount,
                ecAssign,
              } = user
              acc.push([
                sNo,
                leadNo,
                clientType,
                onlyEngagement,
                companyName,
                branchName,
                clientCode,
                clientName,
                cpStatus,
                cpRemarks,
                brideName,
                groomName,
                leadDate,
                eventCount,
                ecAssign,
              ])

              console.log("test", acc)
              return acc
            }, [])
          console.log(usersCsv, "usersCsv")
          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "UnassignedEC.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)

        return response.data
      })
      .catch((error) => Promise.reject(error))
    // specificDispatch(
    //   manageFollowupAction.loadManageFollowupExportList(searchvalue)
    // )
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4">
                      </Col>
                      <Col md="8">
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                              marginBottom: "20px",
                              marginTop: "-41px",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                            marginTop:"-30px",
                            marginRight:"20px"
                          }}

                        >
                        <div className="d-flex flex-row">
                        <h6 className="alter-font">
                            CP - Client Profile
                          </h6>
                         
                        </div>

                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                          expandRow={expandRow}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
 
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: unassigned_details.length,
    data:
      !isEmpty(unassigned_details) && unassigned_details.length > 0
        ? unassigned_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    console.log(page, "page")
    let result =
      !isEmpty(unassigned_details.data) && unassigned_details.data.length > 0
        ? unassigned_details.data
        : []
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(events) ||
      !isEmpty(salesAgent) ||
      !isEmpty(unAssignedData.fromDate) ||
      !isEmpty(unAssignedData.toDate)
    ) {
      var searchCompany = companies && companies ? company : ""
      var searchBranch = branches && branches ? branch : ""
      var searchEvent = !isEmpty(eventValue) && eventValue.length > 0 ? eventValue :""
      var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""
      var searchFromDate =
        unAssignedData && unAssignedData.fromDate
          ? moment(unAssignedData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        unAssignedData && unAssignedData.toDate
          ? moment(unAssignedData.toDate).format("YYYY-MM-DD")
          : ""
      var searchLeadNo =
        unAssignedData && unAssignedData.leadNo ? unAssignedData.leadNo : ""

      var searchvalue = {}
      searchvalue.page = pageChange ? pageCount : 1
      searchvalue.limit = 50
      searchvalue.isManageEC = false
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchAgent) {
        searchvalue.employeeId = searchAgent
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchEvent) {
        searchvalue.eventId = searchEvent
      }
      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }
      if (searchFromDate) {
        searchvalue.eventFromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.eventToDate = searchToDate
      }

      specificDispatch(
        manageUnassignedAction.loadManageunassignedList(searchvalue)
      )
    } else {
      specificDispatch(
        manageUnassignedAction.loadManageunassignedList({
          page: page,
          limit: sizePerPage,
          isManageEC: false,
        })
      )
      
      setPageLoad(!pageLoad)
    }
    

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  //Pagination section end //

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Time
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Food
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Travel
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Location
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Venue Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Crowd Strength
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.eventDetails.length > 0 ? (
              row.eventDetails.map((data) => {
                console.log(data, "row list data")

                const dateFormate =
                  !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

                console.log(dateFormate, "dateFormate")
                const eventFromDate = moment(data.eventDate).format(
                  "YYYY-MM-DD"
                )
                console.log(eventFromDate, "eventFrom Date")
                const eventDate = new Date(data.eventDate)
                console.log(eventDate, "eventDate")
                if (
                  new Date(data.eventDate) >=
                    new Date(unAssignedData.fromDate) &&
                  new Date(data.eventDate) <= new Date(unAssignedData.toDate)
                ) {
                  console.log(data, "expandRow data")
                  return (
                    <tr key={data._id}>
                      <th scope="data">{data.eventNo}</th>
                      <td>{data.eventName}</td>
                      <td>
                        {!isEmpty(data.eventDate)
                          ? moment(data.eventDate).format(dateFormate)
                          : "--"}
                      </td>
                      <th>{data.crewAssemblyTime}</th>
                      <th> {data.food}</th>
                      <th>{data.travelStay}</th>
                      <td>{data.venueLocation}</td>
                      <td>{data.venueName}</td>
                      <td>{data.crowdStrength}</td>
                    </tr>
                  )
                } else if (
                  isEmpty(unAssignedData.fromDate) &&
                  isEmpty(unAssignedData.toDate)
                ) {
                  return (
                    <tr key={data._id}>
                      <th scope="data">{data.eventNo}</th>
                      <td>{data.eventName}</td>
                      <td>
                        {!isEmpty(data.eventDate)
                          ? moment(data.eventDate).format(dateFormate)
                          : "--"}
                      </td>
                      <th>{data.crewAssemblyTime}</th>
                      <td>{data.venueLocation}</td>
                      <td>{data.venueName}</td>
                      <td>{data.crowdStrength}</td>
                    </tr>
                  )
                }
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={7}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            manageUnassignedMetaData
                              ? manageUnassignedMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="events"
                          value={events}
                          isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            manageUnassignedMetaData
                              ? manageUnassignedMetaData.eventOptions
                              : []
                          }
                          placeholder="Select event"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={unAssignedData.fromDate}
                          max={unAssignedData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={unAssignedData.toDate}
                          min={unAssignedData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={unAssignedData.leadNo}
                          // min={unAssignedData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            // onKeyDown={(e) => handleFilter(e)}
                            onClick={(e) => handleFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBarStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                          // onClick={(e) => handleClick()}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  {/* <div className="d-flex flex-row">
                    
                    
                  </div> */}
                  <RemotePagination
                    data={unAssignedTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      !isEmpty(unassigned_details)
                        ? unassigned_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        <div className="d-flex justify-content-center mb-5">
          {modal && (
            <Modal size="xl" show={modal} onHide={toggle}>
              <Modal.Header style={{ backgroundColor: "#e40d8c" }}>
                <h5
                  style={{
                    color: "#ffffff",
                    fontWeight: 800,
                    textTransform: "uppercase",
                  }}
                >
                  Lead No: <span style={{ fontWeight: 600 }}>{leadNo}</span>
                </h5>
              </Modal.Header>

              <Modal.Body>
                <Row className="d-flex flex-row">
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <div className="d-flex justify-content-between">
                      <Label className={"form-label"}>{"Company"}</Label>
                    </div>
                    <Select
                      type="text"
                      name="companyDetails"
                      value={companyDetails}
                      onChange={(e) => setCompanyDetails(e)}
                      options={
                        manageUnassignedMetaData
                          ? manageUnassignedMetaData.companyOptions
                          : []
                      }
                      placeholder="Select Company"
                      classNamePrefix="select2-selection"
                    />
                  </Col>
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <div className="d-flex justify-content-between">
                      <Label className={"form-label"}>{"Branch"}</Label>
                    </div>
                    <Select
                      type="text"
                      name="branchDetails"
                      value={branchDetails}
                      onChange={(e) => setBranchDetails(e)}
                      options={
                        manageUnassignedMetaData
                          ? manageUnassignedMetaData.branchOptions
                          : []
                      }
                      placeholder="Select Branch"
                      classNamePrefix="select2-selection"
                    />
                  </Col>
                  <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                    <div className="d-flex">
                      <Label className={"form-label"}>{"EC Agent"}</Label>
                      <span className="required mx-1">*</span>
                    </div>
                    <ReactSearchAutocomplete
                      name="salesAgentList"
                      items={agentOptions}
                      value={salesAgentList}
                      type="autoComplete"
                      resultStringKeyName="label"
                      showIcon={false}
                      onSelect={(e) => setSalesAgentList(e)}
                      onChange={(e) => setSalesAgentList(e.target.value)}
                      placeholder="Enter EC Agent"
                      fuseOptions={fuseOptions} // Search on both fields
                      styling={{
                        height: "34px",
                        border: "1px solid #ced4da",
                        borderRadius: "4px",
                        backgroundColor: "white",
                        boxShadow: "none",
                        hoverBackgroundColor: "#E40D8C",
                        color: "black",
                        fontSize: "12px",
                        fontFamily: "Courier",
                        iconColor: "green",
                        clearIconMargin: "3px 8px 0 0",
                        zIndex: 100,
                      }}
                    />
                    {simpleValidator.current.message(
                      "salesAgentList",
                      salesAgentList,
                      "required"
                    )}
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  className="btn btn-danger"
                  data-bs-dismiss="modal"
                  onClick={() => setModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  // variant="primary"
                  type="submit"
                  className="btn btn-success"
                  onClick={(e) => handleAssignDetails(e)}
                >
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
          )}
          {btnLoading ? (
            <Modal show={btnLoading} style={{ width: "7%", margin: "18% 50%" }}>
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
                {/* <span>Loading...</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
          {downloadLoading ? (
            <Modal
              show={downloadLoading}
              style={{ width: "7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
                {/* <span>Loading...</span> */}
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </React.Fragment>
  )
}

UnassignedEc.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  name: PropTypes.any,
  FlagExportExcel: PropTypes.any,
  location: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,

  // enableTableFilter: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UnassignedEc)
)
